import React from 'react';
import { ImageUrlInput } from './ImageUrlInput';

interface ImageUrlFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  placeholder?: string;
  error?: string;
}

export const ImageUrlField: React.FC<ImageUrlFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error,
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <ImageUrlInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        error={!!error}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </>
  );
};
